/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal, Radio } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import WithRouter from '../Extensions/WithRouter';
import './AddVersionModal.css';

class ChangeStatusProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCS: props.isOpenMCS,
      isLoading: false,
      rowData: props.rowData,
      radioValue: 'active',
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.closeChangeStatusModal = this.closeChangeStatusModal.bind(this);
    this.updateProjectStatus = this.updateProjectStatus.bind(this);
    this.updateUserStatus = this.updateUserStatus.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMCS, rowData } = this.props;

    if (prevProps.isOpenMCS !== isOpenMCS) {
      this.setState({
        isOpenMCS,
      }, () => {
        if (isOpenMCS) {
          this.setState({
            rowData,
          });
        }
      });
    }
  }

  handleRadioChange(e, { value }) {
    this.setState({
      radioValue: value,
    });
  }

  updateProjectStatus() {
    const { rowData, radioValue } = this.state;
    let i = 0;
    const newArray = [];

    for (i; i < rowData.length; i++) {
      newArray.push(rowData[i].pid);
    }

    this.setState({
      isLoading: true,
    }, () => {
      api
        .updateProjectStatus(
          {
            project_ids: newArray,
            status: radioValue,
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              isLoading: false,
            }, () => {
              this.closeChangeStatusModal();
              if (this.props.completeCallback) {
                this.props.completeCallback(200);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  updateUserStatus() {
    const { rowData, radioValue } = this.state;
    let i = 0;
    const newArray = [];

    for (i; i < rowData.length; i++) {
      newArray.push(rowData[i].uid);
    }

    this.setState({
      isLoading: true,
    }, () => {
      api
        .updateUserStatus(
          {
            user_ids: newArray,
            status: radioValue,
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              isLoading: false,
            }, () => {
              this.closeChangeStatusModal();
              if (this.props.completeCallback) {
                this.props.completeCallback(200);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  closeChangeStatusModal() {
    this.setState({
      isOpenMCS: false,
    });
    this.props.closeModal();
  }

  render() {
    const {
      radioValue, rowData, isLoading, isOpenMCS
    } = this.state;
    const { location, translate } = this.props;

    const pathname = location.pathname ? location.pathname : location;

    return (
      <Modal
        open={isOpenMCS}
        onClose={this.closeChangeStatusModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="setting_popup_header" style={{ position: 'relative' }}>
              <h2 className="popup_name">
                {translate('modal.title.changing_status')}
                {rowData.length !== 0 ? <em>{rowData.length}</em> : null}
              </h2>
              <a
                className="popup_close_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeChangeStatusModal}
                onKeyUp={this.closeChangeStatusModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            {
              isLoading ? (
                <div className="setting_popup_contnets">
                  <Loader
                    style={{
                      position: 'relative',
                      width: '80%',
                      height: '80%',
                      marginBottom: '15%',
                    }}
                  />
                </div>
              ) : (
                <div className="setting_popup_contnets">
                  <div className="setting_popup_content_wrap">
                    <table className="table changing_status_table">
                      <colgroup>
                        <col style={{ width: '50%' }} />
                        <col style={{ width: '50%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>
                            <h3 className="content_title">{translate('modal.title.current_status')}</h3>
                            <div className="setting_popup_content">
                              <div
                                className="table_wrap table_type_3"
                                style={{
                                  padding: '0 10px',
                                  border: '1px solid #e5e5e5',
                                  borderRadius: '5px',
                                }}
                              >
                                <Scrollbars>
                                  <table className="table table_type_3">
                                    <colgroup>
                                      <col style={{ width: '70%' }} />
                                      <col style={{ width: '30%' }} />
                                    </colgroup>
                                    <tbody>
                                      <tr>
                                        {pathname.indexOf('user') > -1
                                          ? (<th>{translate('settings.list.user_name')}</th>) : (<th>{translate('settings.list.project_name')}</th>)}
                                        <th className="tar">{translate('modal.title.status')}</th>
                                      </tr>
                                      {rowData.length !== 0
                                        ? rowData.map((list) => {
                                          return (
                                            <tr key={uuidv4()}>
                                              <td className="strong ">
                                                {list.name || list.userName}
                                              </td>
                                              <td className="strong tar">
                                                {list.status}
                                              </td>
                                            </tr>
                                          );
                                        })
                                        : null}
                                    </tbody>
                                  </table>
                                </Scrollbars>
                              </div>
                            </div>
                          </td>
                          <td>
                            <h3 className="content_title">{translate('modal.title.change_to')}</h3>
                            <div className="setting_popup_content">
                              <div className="text_box">
                                <Radio
                                  label={translate('modal.title.active')}
                                  value="active"
                                  checked={radioValue === 'active'}
                                  onChange={this.handleRadioChange}
                                />
                              </div>
                              <div className="text_box">
                                <Radio
                                  label={translate('modal.title.inactive')}
                                  value="inactive"
                                  checked={radioValue === 'inactive'}
                                  onChange={this.handleRadioChange}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="setting_popup_button_wrap"
                    style={{ bottom: '30px' }}
                  >
                    <a
                      className="button cencel_button"
                      style={{ cursor: 'pointer' }}
                      onClick={this.closeChangeStatusModal}
                      onKeyUp={this.closeChangeStatusModal}
                    >
                      {translate('modal.button.cancel')}
                    </a>
                    <a
                      className="button save_button"
                      style={{ cursor: 'pointer' }}
                      onClick={
                        pathname.indexOf('user') > -1
                          ? this.updateUserStatus
                          : this.updateProjectStatus
                      }
                      onKeyUp={
                        pathname.indexOf('user') > -1
                          ? this.updateUserStatus
                          : this.updateProjectStatus
                      }
                    >
                      {translate('modal.button.save')}
                    </a>
                  </div>
                </div>
              )
            }

          </div>
        </div>
      </Modal>
    );
  }
}

export default WithRouter(ChangeStatusProject);
